import { State } from './types';

const initialState: State = {
	focus: false,
	filterBreakdown: false,
	activeModals: []
};

export default initialState;
